import { lazy } from 'react';

const safeLazy = (importFn) => {
  return lazy(() => {
    // If tab is hidden, return a empty component
    if (document.hidden) {
      return Promise.resolve({
        default: () => null,
      });
    }
    // Otherwise, load normally
    return importFn();
  });
};

export const Login = safeLazy(() => import(/* webpackChunkName: "login" */ './login'), 'login');
export const Dashboard = lazy(() => import(/* webpackChunkName: "dashboard" */ './dashboard'));

export const PublishProduct = lazy(() => import(/* webpackChunkName: "publish-product" */ './publish-product'));

export const ReplicaProduct = lazy(() => import(/* webpackChunkName: "replica-product" */ './replica-prod'));

export const Sellers = lazy(() => import('./sellers/sellers-listing'));

export const Orders = lazy(() => import('./orders/orders-listing'));
export const OrderDetail = lazy(() => import('./orders/order-details'));
export const Carts = lazy(() => import('./orders/carts-listing'));
export const SellerAppeals = lazy(() => import('./seller-appeals'));
export const ReturnOrders = lazy(() => import('./orders/return-order'));
export const AdvancePayment = lazy(() => import('./orders/advance-payment'));

export const Products = lazy(() => import('./products/products-listing'));

export const EditProduct = lazy(() => import('./products/edit-product'));

export const ProductImages = lazy(() => import('./products/product-images'));

export const AddSellers = lazy(() => import('./sellers/add-seller'));

export const CategoriesModeration = lazy(() => import('./moderation/categories-moderation/index'));

export const TypeModeration = lazy(() => import('./moderation/type-moderation/index'));

export const TypeModerationDetail = lazy(() => import('./moderation/type-moderation/type-moderation-detail/index'));

export const CategoryModerationDetail = lazy(
  () => import('./moderation/categories-moderation/category-moderation-detail/index')
);

export const WeightModeration = lazy(() => import('./moderation/weight-moderation/index'));
export const WeightModerationDetail = lazy(
  () => import('./moderation/weight-moderation/weight-moderation-detail/index')
);

export const Reviews = lazy(() => import(/* webpackChunkName: "reviews" */ './reviews'));

export const EditReview = lazy(() => import(/* webpackChunkName: "edit-review" */ './reviews/edit-review'));

export const EditSellerComment = lazy(
  () => import(/* webpackChunkName: "edit-seller-comment" */ './reviews/edit-seller-comment')
);

export const OrderOverview = lazy(() => import(/* webpackChunkName: "order-overview" */ './finance/order-overview'));

export const AccountStatement = lazy(
  () => import(/* webpackChunkName: "account-statement" */ './finance/account-statement')
);

export const AccountStatementDetails = lazy(
  () => import(/* webpackChunkName: "account-statement-detail" */ './finance/account-statement-detail')
);
export const RolesScreen = lazy(
  () => import(/* webpackChunkName: "account-statement-detail" */ './RolesPermissions/roles-listing')
);
export const ManageRoles = lazy(
  () => import(/* webpackChunkName: "account-statement-detail" */ './RolesPermissions/Manage-roles')
);
export const ManageUsersCp = lazy(
  () => import(/* webpackChunkName: "account-statement-detail" */ './Users/Users-listing')
);

export const AllImagesCp = lazy(() => import('./images'));
export const RealTimeStats = lazy(() => import('./real-time-stats'));

export const LocationSettingsList = lazy(() => import('./location-settings'));

export const CallsList = lazy(() => import('./calls'));
export const SalesReport = lazy(() => import('./reports/SalesReport'));
export const FollowUps = lazy(() => import('./kpis/FollowUps'));